<template>
  <div class="component-filter-actionsheet" v-if="isShow" :style="{height: height,top:top }" @touchmove="onTouchemove">
    <div class="filter-actionsheet-mask" @click="onClickMask"></div>
    <div class="filter-actionsheet-content">
      <ul class="filter-actionsheet-ul">
        <li
          class="ellipsis"
          v-for="(item, index) in filterList"
          :key="index"
          :class="{ active: item.selected }"
          @click="onClickFilter(item,index)"
          :clstag="item.clstag"
        >{{item.name}}</li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FilterActionSheet',
  components: {},
  data() {
    return {};
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '100%'
    },
    top: {
      type: String,
      default: '0px'
    },
    filterList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  computed: {},
  created() {},
  methods: {
    onTouchemove(e) {
      e.preventDefault();
    },
    onClickMask() {
      this.$emit('onClickMask');
    },
    onClickFilter(item, index) {
      if (this.filterList && this.filterList.length) {
        this.filterList.map((item, _index) => {
          if (index === _index) {
            item.selected = true;
          } else {
            item.selected = false;
          }
        });
      }

      this.$emit('onClickFilter', this.filterList, item);
    }
  },
  mounted() {},
  destroyed() {
    this.$refs = null;
    this._self = null;
  }
};
</script>

<style lang="scss">
@import '@/scss/mixin.scss';

.component-filter-actionsheet {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;

  .filter-actionsheet-mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    opacity: 0.6;
    background: #000000;
  }

  .filter-actionsheet-content {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    max-height: 80%;
    z-index: 10;
    background: #f7f7f7;

    .filter-actionsheet-ul {
      li {
        position: relative;
        width: 100%;
        height: $rem85;
        padding-left: $rem32;
        line-height: $rem85;
        font-size: $rem28;
        color: #444444;

        &.active {
          color: #c29451;

          &:after {
            position: absolute;
            top: 13px;
            right: $rem32;
            width: $rem32;
            height: $rem32;
            background-image: url('//img12.360buyimg.com/jrpmobile/jfs/t1/392/8/11677/897/5bcee93dEa0df55d2/b515904f911135b1.png');
            background-repeat: no-repeat;
            background-position: 0 0;
            background-size: 100% 100%;
            content: '';
          }
        }
      }
    }
  }
}
</style>
